import { lazy } from "react";

export const ForgotPassword = lazy(() => import("./ForgotPassword"));
export const UpdatePasswordSuccess = lazy(() => import("./UpdatePasswordSuccess"));
export const OtpVerification = lazy(() => import("./OtpVerification"));

